var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"position":"absolute","top":"0","right":"0","z-index":"1000"},on:{"click":function($event){_vm.debug = !_vm.debug}}},[_c('vue-progress-bar'),_c('pre',{directives:[{name:"show",rawName:"v-show",value:(_vm.debug),expression:"debug"}],staticStyle:{"width":"250px"}},[_vm._v(_vm._s({
      total: _vm.service.total,
      progress: _vm.progress,
      duration: _vm.service.duration,
      completed: _vm.service.completed,
      succeeded: _vm.service.succeeded,
      failed: _vm.service.failed,
    }))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }